/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import { action, set } from '@ember/object';
import { FlyInputEvent } from '@customerio/fly-components/types/fly-components/events';

interface AdvancedJsonNameTextareaArgs {
  condition: AttributeCondition | EventAttributeCondition | CollectionAttributeCondition;
  onInput: (value: string | null) => unknown;
}

export default class AdvancedJsonNameTextarea extends Component<AdvancedJsonNameTextareaArgs> {
  @action
  onInput(event: FlyInputEvent<HTMLTextAreaElement>) {
    set(this.args.condition, 'name', event.target.value);
    this.args.onInput(event.target.value);
  }
}
